import i18n from "../i18n";

/**
 * Created by jiachenpan on 16/11/18.
 */

export function isvalidUsername(str) {
  const valid_map = ['admin', 'editor']
  return valid_map.indexOf(str.trim()) >= 0
}

/* 合法uri */
export function validateURL(textval) {
  const urlregex = /^(https?|ftp):\/\/([a-zA-Z0-9.-]+(:[a-zA-Z0-9.&%$-]+)*@)*((25[0-5]|2[0-4][0-9]|1[0-9]{2}|[1-9][0-9]?)(\.(25[0-5]|2[0-4][0-9]|1[0-9]{2}|[1-9]?[0-9])){3}|([a-zA-Z0-9-]+\.)*[a-zA-Z0-9-]+\.(com|edu|gov|int|mil|net|org|biz|arpa|info|name|pro|aero|coop|museum|[a-zA-Z]{2}))(:[0-9]+)*(\/($|[a-zA-Z0-9.,?'\\+&%$#=~_-]+))*$/
  return urlregex.test(textval)
}

/* 小写字母 */
export function validateLowerCase(str) {
  const reg = /^[a-z]+$/
  return reg.test(str)
}

/* 大写字母 */
export function validateUpperCase(str) {
  const reg = /^[A-Z]+$/
  return reg.test(str)
}

/* 大小写字母 */
export function validateAlphabets(str) {
  const reg = /^[A-Za-z]+$/
  return reg.test(str)
}

/**
 * validate email
 * @param email
 * @returns {boolean}
 */
export function validateEmail(email) {
  const re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
  return re.test(email)
}

/* 数字 */
export function validateNumber(val) {
  return (new RegExp(/^-?(?:\d+|\d{1,3}(?:,\d{3})+)(?:\.\d+)?$/).test(val));
}

// 大于0数字
export function validateGtZerroNumber(rule, value, callback) {
  if (value === '' || value === null) {
    let message = i18n.t('public.pleaseEnter');
    callback(new Error(message))
  } else {
    if (isNaN(value) || value <= 0) {
      let message = i18n.t('public.pleaseEnter') + i18n.t('public.gtZerroNumber');
      callback(new Error(message))
    } else {
      callback()
    }
  }
}

// 正数
export function validateMinZerroNumber(rule, value, callback) {
  if (value === '' || value === null) {
    let message = i18n.t('public.pleaseEnter');
    callback(new Error(message))
  } else {
    if (isNaN(value) || value < 0) {
      let message = i18n.t('public.pleaseEnter') + i18n.t('public.minZerroNumber');
      callback(new Error(message))
    } else {
      callback()
    }
  }
}

export function validateIntNum(rule, value, callback) {
  if (value === '' || value === null) {
    let message = i18n.t('public.pleaseEnter');
    callback(new Error(message))
  } else {
    if (isNaN(value) || !(/^-?\d+$/.test(value))) {
      let message = i18n.t('public.pleaseEnter') + i18n.t('public.intNumber');
      callback(new Error(message))
    } else {
      callback()
    }
  }
}

export function validateFloatNum(rule, value, callback) {
  if (value === '' || value === null) {
    let message = i18n.t('public.pleaseEnter');
    callback(new Error(message))
  } else {
    if (isNaN(value)) {
      let message = i18n.t('public.pleaseEnter')+i18n.t('public.number');
      callback(new Error(message))
    } else {
      callback()
    }
  }
}

export function validateEnter(rule, value, callback) {
  if (value === '' || value === null) {
    let message = i18n.t('public.pleaseEnter');
    callback(new Error(message))
  } else {
    callback()
  }
}

export function validateRatio(rule, value, callback) {
  if (value === '' || value === null) {
    let message = i18n.t('public.pleaseEnter')
    callback(new Error(message))
  } else {
    if (parseFloat(value) < 0 || parseFloat(value) > 100) {
      let message = i18n.t('public.pleaseEnter') + ',' + i18n.t('public.between_0_100');
      callback(new Error(message))
    } else {
      callback()
    }
  }
}

export function validateSelect (rule, value, callback) {
  if (value === '' || value === null) {
    let message = i18n.t('public.pleaseSelect');
    callback(new Error(message))
  } else {
    callback()
  }
}
/* Integer */
export function validateInteger(val) {
  return (new RegExp(/^\d+$/).test(val));
}

export function validateMin(val, param) {
  return val >= param;
}

export function validateMax(val, param) {
  return val <= param;
}



// WEBPACK FOOTER //
// ./src/utils/validate.js